import { configureStore } from "@reduxjs/toolkit";
import versusGamesReducer from "./slices/versusGamesSlice";
import gameProviderReducer from "./slices/gameProviderSlice";
import userLevelReducer from "./slices/userLevelSlice";
import fixturesReducer from "./slices/fixturesSlice";
import storeItemsReducer from "./slices/storeItemsSlice";
import tenantReducer from "./slices/tenantSlice";
import alertsReducer from "./slices/alertsSlice";

export const store = configureStore({
  reducer: {
    versusGames: versusGamesReducer,
    gameProvider: gameProviderReducer,
    userLevel: userLevelReducer,
    fixtures: fixturesReducer,
    storeItems: storeItemsReducer,
    tenant: tenantReducer,
    alerts: alertsReducer,
  },
});
